import { Component } from '@angular/core';

@Component({
    selector: 'admin-reports',
    templateUrl: './reports.component.html',
    standalone: false
})
export class ReportsComponent {

  constructor() { }

}
